import i18next from 'i18next';

i18next.addResources('es_CL', 'ProductDetailFooter', {
  add: 'Agregar',
  invalidSelection: 'Seleccion de opción inválida'
});
